import {
  SET_LOADING,
  SAVE_DATA,
  SET_FILTER,
  SET_ACTIVE_PAGE,
  CITY_LOADING,
  SET_CITY_OPTIONS,
  SET_CITY_SELECTED_OPTION,
  SAVE_VM_LIST_DATA,
  SAVE_VM_DETAILS_DATA
} from './constants';

const initialState = {
  loading: true,
  vmData: [],
  vmlistData: [],
  filter: '',
  activePage: 1,
  cityOptions: [],
  cityLoading: true,
  cityDefaultSelected: 'all',
  vmDetailsData: null,
};

export default function (state = initialState, action) {
  console.log('VM/reducer________', action);
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.isLoading,
      };

    case SAVE_DATA:
      return {
        ...state,
        vmData: action.data,
      };

    case SAVE_VM_LIST_DATA:
      console.log('case SAVE_VM_LIST_DATA action.data', action.data);
      return {
        ...state,
        vmlistData: action.data,
      };

    case SAVE_VM_DETAILS_DATA:
      console.log('case SAVE_VM_DETAILS_DATA action.data', action.data);
      return {
        ...state,
        vmDetailsData: action.data,
      };

    case SET_FILTER:
      return {
        ...state,
        filter: action.filter,
      };

    case SET_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.pageNumber,
      };

    case CITY_LOADING:
      return {
        ...state,
        cityLoading: action.loading,
      };

    case SET_CITY_OPTIONS:
      return {
        ...state,
        cityOptions: action.options,
      };

    case SET_CITY_SELECTED_OPTION:
      return {
        ...state,
        cityDefaultSelected: action.value,
      };

    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/Modules/VMs/reducer.js